import { c as _c } from "react/compiler-runtime";
export function AspectRatioIcon(t0) {
  const $ = _c(16);
  const {
    ratio,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let w;
  let h;
  if (ratio === "auto") {
    w = 14;
    h = 14;
  } else {
    let t2;
    if ($[0] !== ratio) {
      t2 = ratio.split(":").map(Number);
      $[0] = ratio;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const [rw, rh] = t2;
    const scale = 14 / Math.max(rw, rh);
    let t3;
    if ($[2] !== rw || $[3] !== scale) {
      t3 = Math.round(rw * scale);
      $[2] = rw;
      $[3] = scale;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    w = Math.max(4, t3);
    let t4;
    if ($[5] !== rh || $[6] !== scale) {
      t4 = Math.round(rh * scale);
      $[5] = rh;
      $[6] = scale;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    h = Math.max(4, t4);
  }
  const t2 = `shrink-0 ${className}`;
  const t3 = (14 - w) / 2;
  const t4 = (14 - h) / 2;
  let t5;
  if ($[8] !== h || $[9] !== t3 || $[10] !== t4 || $[11] !== w) {
    t5 = <rect x={t3} y={t4} width={w} height={h} rx={1} fill="none" stroke="currentColor" strokeWidth={1.5} />;
    $[8] = h;
    $[9] = t3;
    $[10] = t4;
    $[11] = w;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <svg width={14} height={14} viewBox="0 0 14 14" className={t2}>{t5}</svg>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}